<template>
    <Link
        v-if="to"
        :data-cy="cypressId"
        class="tooltip__option"
        :to="to"
        @click="$emit('click', $event)"
    >
        <slot />
    </Link>
    <div
        v-else
        :data-cy="cypressId"
        class="tooltip__option"
        role="button"
        tabindex="0"
        @click="$emit('click', $event)"
        @keydown.enter="$emit('click', $event)"
        @keydown.space.prevent="$emit('click', $event)"
    >
        <slot />
    </div>
</template>

<script lang="ts" setup>
import type { RouteLocationRaw } from 'vue-router';
import Link from './Link.vue';

type Props = {
    to: string | RouteLocationRaw | null,
    cypressId: string | null,
}

type Emits = {
    (e: 'click', event: Event): void,
}

withDefaults(defineProps<Props>(), {
    to: null,
    cypressId: null,
});

defineEmits<Emits>();

</script>

<style lang="scss" scoped>
@import '../../../styles/abstracts/spacings';
@import '../../../styles/abstracts/mixins';
@import '../../../styles/abstracts/variables';

.tooltip__option,
:deep(.tooltip__option) {
    display: block;

    width: 100%;
    padding: $spacing-xs;

    color: var(--theme-color-text-inversed);
    text-align: left;
    text-decoration: none;

    cursor: pointer;

    &:hover {
        background-color: var(--theme-color-surface-secondary-default);
        border-radius: $border-radius-xxs;
    }
}

.tooltip__option:not(:hover) + .tooltip__option:not(:hover),
:deep(.tooltip__option:not(:hover) + .tooltip__option:not(:hover)) {
    @include has-horizontal-rule(0, 'top', --theme-color-surface-primary-default);
}
</style>
